module.exports = __webpack_public_path__ + "static/img/iphone_msp1.5cca51e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_msp1.png
// module id = VNT8
// module chunks = 0